<div class="info-business-page">

  <!-- Loading -->
  <div *ngIf="!business" class="container-lottie">
    <div class="loading-container">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
        containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <div *ngIf="business">

    <!-- Grid layout con areas -->
    <div class="business-grid">

      <!-- Logo -->
      <div class="business-card logo-card">
        <div class="logo-wrapper" (click)="file.click()">
          <div class="logo-img">
            <i class="fa-thin fa-image" *ngIf="!imgControl.value"></i>
            <img fallimg [src]="imgControl.value" alt="Logo organización" *ngIf="imgControl.value" />
          </div>
          <div class="camera-btn">
            <i class="fa-light fa-camera"></i>
          </div>
          <input id="file" #file hidden type="file" accept="image/*" (change)="onFileChange($event)">
        </div>
        <p class="business-name">{{business?.name}}</p>
        <button class="update-photo-btn" (click)="file.click()">
          <i class="fa-light fa-arrow-up-from-bracket"></i>
          Actualizar logo
        </button>
      </div>

      <!-- Datos Legales -->
      <div class="business-card legal-card">
        <div class="card-header">
          <div class="card-header-left">
            <i class="fa-light fa-file-lines card-icon"></i>
            <h3 class="card-title">Datos Legales</h3>
          </div>
          <span class="card-tag">EMPRESA</span>
        </div>
        <div class="card-body">
          <div class="field-group">
            <label class="field-label">NOMBRE FISCAL</label>
            <div class="field-input">
              <span>{{business?.fiscal_name}}</span>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">CIF</label>
            <div class="field-input">
              <span>{{business?.cif}}</span>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">PROPIETARIO/A</label>
            <div class="field-input">
              <div>
                <p class="m-0">{{owner?.name}}</p>
                <p class="m-0 owner-email">{{owner?.email}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Facturación (ocupa las 2 filas de col 3) -->
      <div class="business-card billing-card">
        <div class="card-header">
          <div class="card-header-left">
            <i class="fa-light fa-receipt card-icon"></i>
            <h3 class="card-title">Facturación</h3>
          </div>
          <div class="card-header-left">
            <span class="card-tag">SOLO LECTURA</span>
            <i class="fa-light fa-lock" style="color:#aaa; font-size:0.8rem;"></i>
          </div>
        </div>
        <div class="card-body">
          <div class="field-group">
            <label class="field-label">Nº FACTURACIÓN</label>
            <div class="field-input">
              <span>{{business?.tpv_info.business.billing_prefix}}</span>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">TIPO DE IVA</label>
            <div class="field-input">
              <span>{{business?.tpv_info.business.taxes.value | number:'1.0-0'}}% ({{business?.tpv_info.business.taxes.name}})</span>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">CANALES DE VENTA</label>
            <div class="channel-list">
              <div class="channel-item" *ngFor="let group of groupedChannels" [class.active]="group.active">
                <span class="channel-checkbox">
                  <i class="fal" [class.fa-check-square]="group.active" [class.fa-square]="!group.active"></i>
                </span>
                <span class="channel-name">
                  {{ group.label }}
                  <span *ngIf="group.active && group.detail" class="channel-detail"> – {{ group.detail }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">COMISIONES</label>
            <div class="fee-list" *ngIf="business?.tpv_info.business.fee?.length; else noFee">
              <ng-container *ngFor="let fee of business?.tpv_info.business.fee">

                <!-- Tipos simples: 1, 2 (y 2 con value=0 = Gratuito), 4 (legado) -->
                <div class="fee-row" *ngIf="fee.id_type_fee !== 3">
                  <ng-container [ngSwitch]="fee.id_type_fee">
                    <span *ngSwitchCase="1" class="fee-badge fee-badge-percent">%</span>
                    <ng-container *ngSwitchCase="2">
                      <span *ngIf="fee.value[0]?.value === 0" class="fee-badge fee-badge-free"><i class="fal fa-ban"></i></span>
                      <span *ngIf="fee.value[0]?.value !== 0" class="fee-badge fee-badge-fixed">€</span>
                    </ng-container>
                    <span *ngSwitchCase="4" class="fee-badge fee-badge-free"><i class="fal fa-ban"></i></span>
                  </ng-container>
                  <div class="fee-row-info">
                    <span class="fee-row-name">
                      <ng-container [ngSwitch]="fee.id_type_fee">
                        <span *ngSwitchCase="1">Porcentaje</span>
                        <ng-container *ngSwitchCase="2">
                          <span *ngIf="fee.value[0]?.value === 0">Gratuito</span>
                          <span *ngIf="fee.value[0]?.value !== 0">Fija</span>
                        </ng-container>
                        <span *ngSwitchCase="4">Gratuito</span>
                      </ng-container>
                    </span>
                  </div>
                  <div class="fee-row-value">
                    <ng-container [ngSwitch]="fee.id_type_fee">
                      <span *ngSwitchCase="1">{{ withVat(fee.value[0]?.value) | number:'1.2-2' }}%</span>
                      <ng-container *ngSwitchCase="2">
                        <span *ngIf="fee.value[0]?.value === 0">—</span>
                        <span *ngIf="fee.value[0]?.value !== 0">{{ withVat(fee.value[0]?.value) | number:'1.2-2' }}&nbsp;€</span>
                      </ng-container>
                      <span *ngSwitchCase="4">—</span>
                    </ng-container>
                  </div>
                </div>

                <!-- Tipo 3: Por tramos -->
                <div class="fee-row fee-row-tramos" *ngIf="fee.id_type_fee === 3">
                  <div class="fee-row-tramos-header">
                    <span class="fee-badge fee-badge-range"><i class="fal fa-layer-group"></i></span>
                    <span class="fee-row-name">Por tramos</span>
                  </div>
                  <div class="fee-tramo-table">
                    <div class="fee-tramo-table-row fee-tramo-table-head">
                      <span>Rango de precio</span>
                      <span>Comisión</span>
                    </div>
                    <ng-container *ngFor="let v of fee.value; let i = index; let last = last">
                      <div class="fee-tramo-table-row" [class.fee-tramo-last]="last">
                        <span *ngIf="!last" class="tramo-range">
                          <span class="tramo-from">{{ i === 0 ? '0' : (fee.value[i-1].max | number:'1.0-2') }} €</span>
                          <span class="tramo-arrow">→</span>
                          <span class="tramo-to">{{ v.max | number:'1.0-2' }} €</span>
                        </span>
                        <span *ngIf="last" class="tramo-open">
                          <i class="fal fa-arrow-right"></i>
                          <span>Desde {{ i === 0 ? '0' : (fee.value[i-1].max | number:'1.0-2') }} €</span>
                        </span>
                        <span class="tramo-fee">{{ withVat(v.value) | number:'1.2-2' }} €</span>
                      </div>
                    </ng-container>
                  </div>
                </div>

              </ng-container>
            </div>
            <ng-template #noFee>
              <div class="field-input">
                <span class="text-muted" style="font-size:0.85rem;">Sin comisión configurada</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Información General (col 1, fila 2) -->
      <div class="business-card info-card">
        <div class="card-header">
          <div class="card-header-left">
            <i class="fa-light fa-building card-icon"></i>
            <h3 class="card-title">Información General</h3>
          </div>
          <span class="card-tag">GENERAL</span>
        </div>
        <div class="card-body">

          <div class="field-group">
            <label class="field-label">NOMBRE VISIBLE EN CITYLOK</label>
            <div class="field-input" [class.clickable]="admin" (click)="admin && openUpdateBusiness('nameCitylok', 'Nombre visible en Citylok')">
              <span>{{business?.name}}</span>
              <i class="fa-light fa-pen field-icon" *ngIf="admin"></i>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label">DIRECCIÓN FISCAL</label>
            <div class="field-input" [class.clickable]="admin" (click)="admin && openUpdateBusiness('address', 'Dirección fiscal')">
              <span>{{business?.address}}, {{business?.city?.name || business?.city}}, {{business?.postal_code}}, {{business?.country?.name}}</span>
              <i class="fa-light fa-pen field-icon" *ngIf="admin"></i>
            </div>
          </div>

          <div class="field-group field-group-grow">
            <label class="field-label">
              DESCRIPCIÓN
              <i class="fas fa-info-circle icon-info-label" matTooltip="Descripción que aparecerá en la página de la organización."></i>
            </label>
            <div class="field-input field-input-multiline" [class.clickable]="admin" (click)="admin && openUpdateBusiness('description', 'Descripción')">
              <span [innerHTML]="description || 'Sin descripción'"></span>
              <i class="fa-light fa-pen field-icon" *ngIf="admin"></i>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label">
              URL PERSONALIZADA
              <i class="fas fa-info-circle icon-info-label" matTooltip="Crea un enlace personalizado de tu organización para compartirlo y promocionar tus eventos fácilmente."></i>
            </label>
            <div class="field-input" [class.clickable]="admin" (click)="admin && openUpdateBusiness('slug', 'URL personalizada')">
              <div class="d-flex align-items-center gap-2">
                <i class="fal fa-link" style="color: var(--color-primary); font-size: 0.85rem;"></i>
                <a class="link-value" [href]="getBusinessPublicUrl()" target="_blank" (click)="$event.stopPropagation()">{{ getBusinessPublicUrl() }}</a>
                <i class="fal fa-copy pointer-in" matTooltip="Copiar enlace" [matTooltipShowDelay]="0" style="color: var(--color-primary); font-size: 0.85rem;" (click)="$event.stopPropagation(); copyBusinessUrl()"></i>
              </div>
              <i class="fa-light fa-pen field-icon" *ngIf="admin"></i>
            </div>
          </div>

        </div>
      </div>

      <!-- Condiciones Generales (cols 2-3, fila 2) -->
      <div class="business-card conds-card">
        <div class="card-header">
          <div class="card-header-left">
            <i class="fa-light fa-file-contract card-icon"></i>
            <h3 class="card-title">Condiciones Generales</h3>
            <i class="fas fa-info-circle icon-info-label" style="color: var(--color-primary);" matTooltip="Condiciones generales que se usan por defecto en la impresión de las entradas."></i>
          </div>
        </div>
        <div class="card-body">
          <div class="conds-text" [class.clickable]="admin" (click)="admin && openUpdateBusiness('general_conditions', 'Condiciones generales')">
            <span *ngIf="business.general_conditions" [innerHTML]="business.general_conditions"></span>
            <span *ngIf="!business.general_conditions" class="conds-empty">Sin condiciones generales definidas. Haz clic para añadir.</span>
            <i class="fa-light fa-pen field-icon" *ngIf="admin"></i>
          </div>
        </div>
      </div>

    </div>

    <!-- Solicitar cambios - TODO: API no disponible temporalmente -->
    <!-- <div class="contact-card" (click)="openContactBusiness()" *ngIf="admin">
      <i class="fa-light fa-envelope"></i>
      <p class="m-0">Solicitar cambios</p>
    </div> -->

  </div>
</div>
